module.exports = __webpack_public_path__ + "img/keder_enzianblau_ral5010.2d91c09a.jpg";